// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.food-ready {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 20px;
}
.food-ready .food-ready-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 32px;
  text-align: center;
}
.food-ready .food-ready-header .food-ready-icon-wrapper {
  width: 90px;
  height: 90px;
  background-color: #FFFBEF;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}
.food-ready .food-ready-header .food-ready-icon-wrapper .food-ready-icon {
  font-size: 50px;
  color: #8E7E54;
}
.food-ready .food-ready-header .food-ready-title {
  font-size: 18px;
  font-weight: 600;
  color: #8E7E54;
  margin: 0 0 8px 0;
}
.food-ready .food-ready-header .food-ready-subtitle {
  font-size: 13px;
  font-weight: 400;
  color: #595959;
  margin: 0;
  max-width: 340px;
  line-height: 1.4;
}
.food-ready .qr-code-section {
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
}
.food-ready .qr-code-section .qr-code-image {
  width: 200px;
  height: 200px;
  border-radius: 8px;
}
.food-ready .order-details-section {
  width: 100%;
  background-color: #FFFFFF;
  border: 1px solid #F0F0F0;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
}
.food-ready .order-details-section .order-status-badge {
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  margin-bottom: 16px;
  display: inline-block;
}
.food-ready .order-details-section .order-status-badge.ready {
  background-color: #E6F7FF;
  color: #1890FF;
  border: 1px solid #1890FF;
}
.food-ready .order-details-section .order-detail-row {
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
  gap: 4px;
}
.food-ready .order-details-section .order-detail-row:last-child {
  margin-bottom: 0;
}
.food-ready .order-details-section .order-detail-row .detail-label {
  font-size: 13px;
  color: #595959;
  font-weight: 400;
}
.food-ready .order-details-section .order-detail-row .detail-value {
  font-size: 16px;
  color: #8E7E54;
  font-weight: 500;
}
.food-ready .order-details-section .order-detail-row .detail-value div {
  margin-bottom: 4px;
  color: #8E7E54;
}
.food-ready .order-details-section .order-detail-row .detail-value div:last-child {
  margin-bottom: 0;
}
.food-ready .order-details-section .how-to-collect {
  width: 100%;
  margin-top: 16px;
}
.food-ready .order-details-section .how-to-collect .how-to-collect-title {
  font-size: 14px;
  font-weight: 500;
  color: #8E7E54;
  margin: 0 0 12px 0;
}
.food-ready .order-details-section .how-to-collect .how-to-collect-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.food-ready .order-details-section .how-to-collect .how-to-collect-list li {
  font-size: 13px;
  font-weight: 400;
  color: #595959;
  line-height: 1.6;
  margin-bottom: 6px;
}
.food-ready .order-details-section .how-to-collect .how-to-collect-list li:last-child {
  margin-bottom: 0;
}
/*# sourceMappingURL=FoodReady.css.map */`, "",{"version":3,"sources":["webpack://./FoodReady.less","webpack://./src/containers/ReceiptPage/components/FoodReady.less"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;ACCD;ADLA;EAOE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;ACCF;ADZA;EAcG,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;ACCH;ADtBA;EAwBI,eAAA;EACA,cAAA;ACCJ;AD1BA;EA8BG,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;ACDH;ADhCA;EAqCG,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;ACFH;ADxCA;EA+CE,mBAAA;EACA,aAAA;EACA,uBAAA;ACJF;AD7CA;EAoDG,YAAA;EACA,aAAA;EACA,kBAAA;ACJH;ADlDA;EA2DE,WAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;ACNF;AD1DA;EAmEG,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;ACNH;ADQG;EACC,yBAAA;EACA,cAAA;EACA,yBAAA;ACNJ;ADvEA;EAkFG,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;ACRH;ADUG;EACC,gBAAA;ACRJ;ADhFA;EA4FI,eAAA;EACA,cAAA;EACA,gBAAA;ACTJ;ADrFA;EAkGI,eAAA;EACA,cAAA;EACA,gBAAA;ACVJ;AD1FA;EAuGK,kBAAA;EACA,cAAA;ACVL;ADYK;EACC,gBAAA;ACVN;ADjGA;EAkHG,WAAA;EACA,gBAAA;ACdH;ADrGA;EAsHI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;ACdJ;AD3GA;EA6HI,gBAAA;EACA,UAAA;EACA,SAAA;ACfJ;ADhHA;EAkIK,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;ACfL;ADiBK;EACC,gBAAA;ACfN;AACA,wCAAwC","sourcesContent":[".food-ready {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding-top: 20px;\n\n\t.food-ready-header {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tmargin-bottom: 32px;\n\t\ttext-align: center;\n\n\t\t.food-ready-icon-wrapper {\n\t\t\twidth: 90px;\n\t\t\theight: 90px;\n\t\t\tbackground-color: #FFFBEF;\n\t\t\tborder-radius: 50%;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tmargin-bottom: 16px;\n\n\t\t\t.food-ready-icon {\n\t\t\t\tfont-size: 50px;\n\t\t\t\tcolor: #8E7E54;\n\t\t\t}\n\t\t}\n\n\t\t.food-ready-title {\n\t\t\tfont-size: 18px;\n\t\t\tfont-weight: 600;\n\t\t\tcolor: #8E7E54;\n\t\t\tmargin: 0 0 8px 0;\n\t\t}\n\n\t\t.food-ready-subtitle {\n\t\t\tfont-size: 13px;\n\t\t\tfont-weight: 400;\n\t\t\tcolor: #595959;\n\t\t\tmargin: 0;\n\t\t\tmax-width: 340px;\n\t\t\tline-height: 1.4;\n\t\t}\n\t}\n\n\t.qr-code-section {\n\t\tmargin-bottom: 24px;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\n\t\t.qr-code-image {\n\t\t\twidth: 200px;\n\t\t\theight: 200px;\n\t\t\tborder-radius: 8px;\n\t\t}\n\t}\n\n\t.order-details-section {\n\t\twidth: 100%;\n\t\tbackground-color: #FFFFFF;\n\t\tborder: 1px solid #F0F0F0;\n\t\tborder-radius: 12px;\n\t\tpadding: 20px;\n\t\tmargin-bottom: 24px;\n\n\t\t.order-status-badge {\n\t\t\tpadding: 4px 12px;\n\t\t\tborder-radius: 4px;\n\t\t\tfont-size: 12px;\n\t\t\tfont-weight: 400;\n\t\t\tmargin-bottom: 16px;\n\t\t\tdisplay: inline-block;\n\n\t\t\t&.ready {\n\t\t\t\tbackground-color: #E6F7FF;\n\t\t\t\tcolor: #1890FF;\n\t\t\t\tborder: 1px solid #1890FF;\n\t\t\t}\n\t\t}\n\n\t\t.order-detail-row {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tmargin-bottom: 12px;\n\t\t\tgap: 4px;\n\n\t\t\t&:last-child {\n\t\t\t\tmargin-bottom: 0;\n\t\t\t}\n\n\t\t\t.detail-label {\n\t\t\t\tfont-size: 13px;\n\t\t\t\tcolor: #595959;\n\t\t\t\tfont-weight: 400;\n\t\t\t}\n\n\t\t\t.detail-value {\n\t\t\t\tfont-size: 16px;\n\t\t\t\tcolor: #8E7E54;\n\t\t\t\tfont-weight: 500;\n\n\t\t\t\tdiv {\n\t\t\t\t\tmargin-bottom: 4px;\n\t\t\t\t\tcolor: #8E7E54;\n\n\t\t\t\t\t&:last-child {\n\t\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.how-to-collect {\n\t\t\twidth: 100%;\n\t\t\tmargin-top: 16px;\n\n\t\t\t.how-to-collect-title {\n\t\t\t\tfont-size: 14px;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tcolor: #8E7E54;\n\t\t\t\tmargin: 0 0 12px 0;\n\t\t\t}\n\n\t\t\t.how-to-collect-list {\n\t\t\t\tlist-style: none;\n\t\t\t\tpadding: 0;\n\t\t\t\tmargin: 0;\n\n\t\t\t\tli {\n\t\t\t\t\tfont-size: 13px;\n\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\tcolor: #595959;\n\t\t\t\t\tline-height: 1.6;\n\t\t\t\t\tmargin-bottom: 6px;\n\n\t\t\t\t\t&:last-child {\n\t\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n",".food-ready {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  padding-top: 20px;\n}\n.food-ready .food-ready-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 32px;\n  text-align: center;\n}\n.food-ready .food-ready-header .food-ready-icon-wrapper {\n  width: 90px;\n  height: 90px;\n  background-color: #FFFBEF;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 16px;\n}\n.food-ready .food-ready-header .food-ready-icon-wrapper .food-ready-icon {\n  font-size: 50px;\n  color: #8E7E54;\n}\n.food-ready .food-ready-header .food-ready-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #8E7E54;\n  margin: 0 0 8px 0;\n}\n.food-ready .food-ready-header .food-ready-subtitle {\n  font-size: 13px;\n  font-weight: 400;\n  color: #595959;\n  margin: 0;\n  max-width: 340px;\n  line-height: 1.4;\n}\n.food-ready .qr-code-section {\n  margin-bottom: 24px;\n  display: flex;\n  justify-content: center;\n}\n.food-ready .qr-code-section .qr-code-image {\n  width: 200px;\n  height: 200px;\n  border-radius: 8px;\n}\n.food-ready .order-details-section {\n  width: 100%;\n  background-color: #FFFFFF;\n  border: 1px solid #F0F0F0;\n  border-radius: 12px;\n  padding: 20px;\n  margin-bottom: 24px;\n}\n.food-ready .order-details-section .order-status-badge {\n  padding: 4px 12px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 400;\n  margin-bottom: 16px;\n  display: inline-block;\n}\n.food-ready .order-details-section .order-status-badge.ready {\n  background-color: #E6F7FF;\n  color: #1890FF;\n  border: 1px solid #1890FF;\n}\n.food-ready .order-details-section .order-detail-row {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 12px;\n  gap: 4px;\n}\n.food-ready .order-details-section .order-detail-row:last-child {\n  margin-bottom: 0;\n}\n.food-ready .order-details-section .order-detail-row .detail-label {\n  font-size: 13px;\n  color: #595959;\n  font-weight: 400;\n}\n.food-ready .order-details-section .order-detail-row .detail-value {\n  font-size: 16px;\n  color: #8E7E54;\n  font-weight: 500;\n}\n.food-ready .order-details-section .order-detail-row .detail-value div {\n  margin-bottom: 4px;\n  color: #8E7E54;\n}\n.food-ready .order-details-section .order-detail-row .detail-value div:last-child {\n  margin-bottom: 0;\n}\n.food-ready .order-details-section .how-to-collect {\n  width: 100%;\n  margin-top: 16px;\n}\n.food-ready .order-details-section .how-to-collect .how-to-collect-title {\n  font-size: 14px;\n  font-weight: 500;\n  color: #8E7E54;\n  margin: 0 0 12px 0;\n}\n.food-ready .order-details-section .how-to-collect .how-to-collect-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n.food-ready .order-details-section .how-to-collect .how-to-collect-list li {\n  font-size: 13px;\n  font-weight: 400;\n  color: #595959;\n  line-height: 1.6;\n  margin-bottom: 6px;\n}\n.food-ready .order-details-section .how-to-collect .how-to-collect-list li:last-child {\n  margin-bottom: 0;\n}\n/*# sourceMappingURL=FoodReady.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
